import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";
import {OrderType} from "../../../types";
import OrderItem from "./OrderItem";
import OrderAction from "./OrderAction";
import CreditCard from "./CreditCard";
import OrderStage from "./OrderStage";

@usingJsonToModelConvertor
export class OrderStageInfo extends Model{

    @fromJsonObject({key: 'text'})
    public text!: string;

    @fromJsonObject({key: 'general_status'})
    public generalStatus!: "normal"|"aborted"|"done";

}

@usingJsonToModelConvertor
export default class Order extends Model {

    @fromJsonObject({key: 'id'})
    public id!: number;

    @fromJsonObject({key: 'branch_id'})
    public branchId!: number;

    @fromJsonObject({key: 'type'})
    public type!: OrderType;

    @fromJsonObject({key: 'items', modelClass: OrderItem, isArray: true})
    public items!: OrderItem[];

    @fromJsonObject({key: 'order_code'})
    public orderCode!: string | null;

    @fromJsonObject({key: 'client_description'})
    public clientDescription!: string | null;

    @fromJsonObject({key: 'table_id'})
    public tableId!: number | null;

    @fromJsonObject({key: 'invoice_code'})
    public invoiceCode!: string | null;

    @fromJsonObject({key: 'tax_price'})
    public taxPrice!: number;

    @fromJsonObject({key: 'delivery_method'})
    public deliveryMethod!: string | null;

    @fromJsonObject({key: 'delivery_name'})
    public deliveryName!: string | null;

    @fromJsonObject({key: 'delivery_phone'})
    public deliveryPhone!: string | null;

    @fromJsonObject({key: 'delivery_latlong'})
    public deliveryLatlong!: string | null;

    @fromJsonObject({key: 'delivery_price'})
    public deliveryPrice!: number;

    @fromJsonObject({key: 'discount_code'})
    public discountCode!: string | null;

    @fromJsonObject({key: 'payment_method'})
    public paymentMethod!: string | null;

    @fromJsonObject({key: 'coupon_id'})
    public couponId!: number | null;

    @fromJsonObject({key: 'coupon_discount_amount'})
    public couponDiscountAmount!: number | null;

    @fromJsonObject({key: 'code_discount_amount'})
    public codeDiscountAmount!: number | null;

    @fromJsonObject({key: 'products_discount_amount'})
    public productsDiscountAmount!: number | null;

    @fromJsonObject({key: 'cart_discount_amount'})
    public cartDiscountAmount!: number | null;

    @fromJsonObject({key: 'total_payable_price'})
    public totalPayablePrice!: number | null;

    @fromJsonObject({key: 'cart_total_price'})
    public cartTotalPrice!: number | null;

    @fromJsonObject({key: 'ipg_wage'})
    public IPGWage!: number | null;

    @fromJsonObject({key: 'total_discount'})
    public totalDiscount!: number | null;

    @fromJsonObject({key: 'status'})
    public status!: 1;

    @fromJsonObject({key: 'stages', modelClass: String, isArray: true})
    public stages!: string[];

    @fromJsonObject({key: 'action', modelClass: OrderAction, isArray: false})
    public action!: OrderAction;

    @fromJsonObject({key: 'card_to_pay', modelClass: CreditCard, isArray: false})
    public cardToPay!: CreditCard;

    @fromJsonObject({key: 'summary'})
    public summary!: string;

    @fromJsonObject({key: 'delivery_method_text'})
    public deliveryMethodText!: string;

    @fromJsonObject({key: 'submit_time_persian'})
    public submitTimePersian!: string;

    @fromJsonObject({key: 'preparation_time'})
    public preparationTime!: number;

    @fromJsonObject({key: 'total_packing_price'})
    public totalPackingPrice!: number;

    @fromJsonObject({key: 'ipg_wage'})
    public ipgWage!: number;

    @fromJsonObject({key: 'stage_info', modelClass: OrderStage, isArray: true})
    public stageInfo!: OrderStage[];

    @fromJsonObject({key: 'finalization_time_ago'})
    public finalizationTimeAgo!: string | null;

    @fromJsonObject({key: 'is_paid'})
    public isPaid!: boolean;

    public submitDateAndTime(){
        if(this.submitTimePersian == null)
            return {
                date: "",
                time: ""
            }
        const dat = this.submitTimePersian.split(" ");
        return {
            date: dat[0],
            time: dat[1]
        }
    }

    public getLastStageInfo(): OrderStage|undefined{
        return this?.stageInfo[this?.stageInfo.length -1 ];
    }

    public getLastStageStatusText(){
        return this.getLastStageInfo()?.textStatus ?? "نامشخص"
    }

    public currentStageNumber(): number{
        return this.getLastStageInfo()?.stageNumber ?? 0;
    }

    public orderIsDone():boolean{
        return this.getLastStageInfo()?.generalStatus == "done" ||
        this.getLastStageInfo()?.generalStatus == "aborted";
    }
    public orderItemsStringArray(): string[]{
        let texts :string[] = [];
        this.items.map((item, index)=>{
            texts.push(
                item.name
            )
        });
        return texts;
    }

    public getPaymentTypeStringTag(): string{
        switch (this.paymentMethod){
            case "ipg":
                return "پرداخت آنلاین";
            default:
            case "pos":
                return "پرداخت حضوری";
            case "ctc":
                return "کارت به کارت";
        }

    }

    public getDeliveryStringTag(): string{
        switch (this.deliveryMethod){
            case "personal":
                return "دریافت حضوری";
            case "express":
                return "پیک رستوران";
            case "manual":
                return "ارسال با آژانس";
            default:
                return "نامشخص";
        }
    }

    // toCardItems(): CartItem[]{
    //     let cartItems:CartItem[] = [];
    //     this.items.map(orderItem=>{
    //     })
    // }
}
